import { Text } from 'pixi.js';

export class PicLabel extends Text {

  constructor(el, offset, index) {
    super();

    if (el.width === undefined) {
      el.width = 0
      el.height = 0
      el.y += 50
    }

    this.structureVertical = el.width < el.height

    this.picId = 'text_' + el.id;
    this.picText = this._GetNameEntity(el, index);
    this.picFontSize = el.radius ? 15 : 2.5;

    // Coordenadas del recuadro original
    this.rectX = Math.abs(el.x + offset.x);
    this.rectY = Math.abs(el.y - offset.y);
    this.rectWidth = el.width;
    this.rectHeight = el.height;

    this.init()
  }

  init() {
    this.text = this.picText;

    // Anchor al centro del texto
    this.anchor.set(0.5, 0.5);

    // Desactivar eventos - los labels no necesitan interacción
    this.eventMode = 'none';

    // Factor de escala para renderizar texto más grande (mejor calidad al zoom)
    const scaleFactor = 20;

    // Posición: centro exacto del recuadro
    this.x = this.rectX + this.rectWidth / 2;
    this.y = this.rectY + this.rectHeight / 2;

    // Rotación para estructuras verticales
    if (this.structureVertical) {
      this.rotation = -Math.PI / 2;  // -90 grados
    } else {
      this.rotation = 0;
    }

    // El ancho disponible para el texto (para word wrap)
    const availableWidth = this.structureVertical ? this.rectHeight : this.rectWidth;

    // Estilo del texto - renderizado grande para calidad
    this.style = {
      fontSize: this.picFontSize * scaleFactor,
      fontWeight: '500',  // Semi-bold
      fill: 0x000000,
      align: 'center',
      wordWrap: true,
      wordWrapWidth: availableWidth * scaleFactor
    };

    // Resolución optimizada (2 es suficiente para buena calidad)
    this.resolution = 2;

    // Escalar hacia abajo para mantener el tamaño visual correcto
    this.scale.set(1 / scaleFactor);
  }

  setText(text) {
    this.text = text;
  }

  setX(x) {
    this.x = x;
  }

  _GetNameEntity(entity, index) {
    if ( entity.name != null )
      return entity.name

    return 'E.' + entity.type.charAt(0).toUpperCase() + '.' + (index + 1)

  }
}
